//folha
import FolhaPagamentoPorCpfComponent from "@/views/relatorios-gestao/folha/FolhaPagamentoPorCpf.vue";
import ServidoresMaisVinculosComponent from "@/views/relatorios-gestao/folha/ServidoresMaisVinculos.vue";
import ServidoresComDoisVinculosComponent from "@/views/relatorios-gestao/folha/ServidoresComDoisVinculos.vue";

//execução
import IndicesEstrategicosPorMunicipioComponent from "@/views/relatorios-gestao/execucao/IndicesEstrategicosPorMunicipio.vue";
import ReceitaCorrenteLiquidaComponent from "@/views/relatorios-gestao/execucao/ReceitaCorrenteLiquida.vue";

//edu
import RelatorioGestaoEduPainelInfo from "@/views/relatorios-gestao/educacao/RelatorioGestaoEduPainelInfo.vue";
import AlunosMatriculadosEmMaisDeUmMunicipio from "@/views/relatorios-gestao/educacao/AlunosMatriculadosEmMaisDeUmMunicipio.vue";
import TurmasMultiseriadas from "@/views/relatorios-gestao/educacao/TurmasMultiseriadas.vue";

//pca
import RelatorioGestaoPcaRolResponsaveis from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaRolResponsaveis.vue";
import RelatorioGestaoPcaRdpce from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaReceitaDespesaPorCatEconomica.vue";
import RelatorioGestaoPcaRgr from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaResumoGeralReceita.vue";
import RelatorioGestaoPcaNd from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaNaturezaDespesa.vue";
import RelatorioGestaoPcaPofspa from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaPofspa.vue";
import RelatorioGestaoPcaFspa from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaFspa.vue";
import RelatorioGestaoPcaFsp from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaFsp.vue";
import RelatorioGestaoPcaOrgaoFuncao from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaOrgaoFuncao.vue";
import RelatorioGestaoPcaCroa from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaCroa.vue";
import RelatorioGestaoPcaCdar from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaCdar.vue";
import RelatorioGestaoPcaBoc from "@/views/relatorios-gestao/pca/RelatorioGestaoPcaBoc.vue";

const relatoriosRotas = [
  //EXECUÇÃO
  {
    path: "/relatorios-gestao/execucao/indices-estrategicos-por-municipio",
    name: "relatorios-gestao--indices-estrategicos-por-municipio",
    component: IndicesEstrategicosPorMunicipioComponent,
  },
  {
    path: "/relatorios-gestao/execucao/receita-corrente-liquida",
    name: "relatorios-gestao--receita-corrente-liquida",
    component: ReceitaCorrenteLiquidaComponent,
  },
  //FOLHA
  {
    path: "/relatorios-gestao/folha/servidores-com-mais-um-vinculo",
    name: "relatorios-gestao--servidores-com-dois-vinculos",
    component: ServidoresComDoisVinculosComponent,
  },
  {
    path: "/relatorios-gestao/folha/servidores-com-mais-dois-vinculos",
    name: "relatorios-gestao--servidores-com-mais-dois-vinculos",
    component: ServidoresMaisVinculosComponent,
  },
  {
    path: "/relatorios-gestao/folha/folha-pagamento-por-cpf",
    name: "relatorios-gestao--folha-pagamento-por-cpf",
    component: FolhaPagamentoPorCpfComponent,
  },
  //EDUCAÇÃO
  {
    path: "/relatorios-gestao/educacao/painel-informacoes",
    name: "relatorios-gestao--educacao-painel-informacoes",
    component: RelatorioGestaoEduPainelInfo,
  },
  {
    path: "/relatorios-gestao/educacao/alunos-matriculados-em-mais-de-um-municipio",
    name: "relatorios-gestao--educacao-alunos-matriculados-em-mais-de-um-municipio",
    component: AlunosMatriculadosEmMaisDeUmMunicipio,
  },
  {
    path: "/relatorios-gestao/educacao/turmas-multiseriadas",
    name: "relatorios-gestao--educacao-turmas-multiseriadas",
    component: TurmasMultiseriadas,
  },
  //PCA
  {
    path: "/relatorios-gestao/pca/rdr",
    name: "relatorios-gestao--rol-de-responsaveis-por-ug",
    component: RelatorioGestaoPcaRolResponsaveis,
  },
  {
    path: "/relatorios-gestao/pca/anexo1-rdpce",
    name: "relatorios-gestao--receita-despesa-por-categoria-economica",
    component: RelatorioGestaoPcaRdpce,
  },
  {
    path: "/relatorios-gestao/pca/anexo2-rgr",
    name: "relatorios-gestao--resumo-geral-receita",
    component: RelatorioGestaoPcaRgr,
  },
  {
    path: "/relatorios-gestao/pca/anexo2-nd",
    name: "relatorios-gestao--natureza-despesa",
    component: RelatorioGestaoPcaNd,
  },
  {
    path: "/relatorios-gestao/pca/anexo6-pofspa",
    name: "relatorios-gestao--poder-orgao-funcao-subfuncao-projeto-atividade",
    component: RelatorioGestaoPcaPofspa,
  },
  {
    path: "/relatorios-gestao/pca/anexo7-fspa",
    name: "relatorios-gestao--funcao-subfuncao-projeto-atividade",
    component: RelatorioGestaoPcaFspa,
  },
  {
    path: "/relatorios-gestao/pca/anexo8-fsp",
    name: "relatorios-gestao--funcao-subfuncao-programa",
    component: RelatorioGestaoPcaFsp,
  },
  {
    path: "/relatorios-gestao/pca/anexo9-of",
    name: "relatorios-gestao--orgao-funcao",
    component: RelatorioGestaoPcaOrgaoFuncao,
  },
  {
    path: "/relatorios-gestao/pca/anexo10-croa",
    name: "relatorios-gestao--comparativo-receita-orcada-arrecadada",
    component: RelatorioGestaoPcaCroa,
  },
  {
    path: "/relatorios-gestao/pca/anexo11-cdar",
    name: "relatorios-gestao--comparativo-despesa-autorizada-realizada",
    component: RelatorioGestaoPcaCdar,
  },
  {
    path: "/relatorios-gestao/pca/boc",
    name: "relatorios-gestao--balanco-orcamentario-consolidado",
    component: RelatorioGestaoPcaBoc,
  },
];

export { relatoriosRotas };
